const NotFoundPage = () => (
  <div className="text-center py-5">
    <h1 className="display-1 fw-bold text-danger">404</h1>
    <h2 className="fs-2 fw-semibold text-dark mb-3">Page Not Found</h2>
    <p className="fs-5 text-muted mb-4 col-lg-6 mx-auto">
      Sorry, the page you are looking for does not exist, might have been removed, or is temporarily unavailable.
    </p>
    <a href="/" className="btn btn-primary btn-lg">Go Back to Home</a>
  </div>
);

export default NotFoundPage;